// for Main Page
export const inboxAutosetMaps = {
  dev: {
    'maywarin.sriamnuai@one-line.com': {
      urgency: 'V-VIP',
    },
  },
  staging: {
    'na.csvc.priorityreeferdoc_test@one-line.com': {
      urgency: 'V-VIP',
    },
  },
  prod: {
    'na.ofs.splsi@one-line.com': {
      urgency: 'V-VIP',
    },
  },
};
